$(document).ready(function () {
  var swiperContainer = $(".swiper-container_cart");
  var slides = swiperContainer.find(".swiper-wrapper .swiper-slide");
  var buttons = $(".slider_buttons_ctm_cart");
  // Swiper: Slider
  new Swiper(".swiper-container_cart", {
    slidesPerView: 1,
    nextButton: ".swiper-button-next-ctm_cart",
    prevButton: ".swiper-button-prev-ctm_cart",
    paginationClickable: true,
  });
  if (slides.length === 1) {
    buttons.addClass("single-slide");
  }
  if (slides.length === 0) {
    swiperContainer.hide();
  }
});


//   const inputFields = document.querySelectorAll(".required");

// inputFields.forEach(inputField => {
//   const inputError = inputField.closest(".line_property_error");
//   const submitButton = document.querySelector(".product-form__submit");
//   const inputValue = inputField.value.trim();

//   inputField.addEventListener("input", function () {
//     const currentValue = inputField.value.trim();
//     console.log(currentValue);

//     if (currentValue !== "") {
//       if (submitButton) {
//         submitButton.removeAttribute("disabled");
//       }
//       if (inputError) {
//         inputError.style.display = "none";
//       }
//     } 
//     if (currentValue > 1) {
//      submitButton.removeAttribute("disabled");
//     }
//   });
// });
